/* eslint-disable no-duplicate-imports */
/* eslint-disable prettier/prettier */
/* eslint-disable react/jsx-key */

import {
  Box,
  Grid,
  Dialog,
  Typography,
  DialogContent,
  Divider,
} from '@mui/material';

import {
  topicArray,
  bioFormatter,
  industryArray,
  capitalizeFirstLetter,
  formatNumberWithCommas,
} from '../../../components/common';

import MyChip from '../../../components/MyChip';
import UserinfoCard from '../../../components/UserinfoCard';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import MatchDetailsPopupLoader from './MatchDetailsPopupLoader';
import CommonModalHeader from '../../../../../components/DialogUi/CommonModalHeader';
import { SvgIcon } from "@mui/material";

const DoubleArrowIcon = ({ color = "#868686", size = 24, ...props }) => {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 24 24"
      sx={{
        width: size,
        height: size,
      }}
    >
      {/* Left arrow */}
      <path
        d="M10 6 L4 12 L10 18"
        stroke={color}
        strokeWidth="2"
        fill="none"
        strokeLinecap="square"
      />

      {/* Right arrow */}
      <path
        d="M14 6 L20 12 L14 18"
        stroke={color}
        strokeWidth="2"
        fill="none"
        strokeLinecap="square"
      />
    </SvgIcon>
  );
};



const MatchUserCard = ({ name, headshot, role }: any) => {
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        alignItems: 'flex-start',
        '*': {
        fontFamily: 'Open Sans !important',
      },
      '*::before': {
        fontFamily: 'Open Sans !important',
      },
      '*::after': {
        fontFamily: 'Open Sans !important',
      },
      }}
    >
      {/* Avatar + Name */}
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '5px',
        }}
      >
        {/* Avatar */}
        <Box
          sx={{
            width: 75,
            height: 75,
            position: 'relative',
            borderRadius: '50%',
            backgroundImage: `url(${headshot || 'https://placehold.co/75x75'})`,
          }}
        >
          <img
            src={headshot}
            style={{
              width: 75,
              height: 75,
              position: 'absolute',
              top: 0,
              left: 0,
              borderRadius: '50%',
              objectFit: 'cover',
            }}
          />
        </Box>

        {/* Name */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '5px',
            alignItems: 'center',
            width: '100%',
            '*': {
        fontFamily: 'Open Sans !important',
      },
      '*::before': {
        fontFamily: 'Open Sans !important',
      },
      '*::after': {
        fontFamily: 'Open Sans !important',
      },
          }}
        >
          <Typography
            sx={{
              color: 'var(--Text-text-primary, #FDFDFD)',
              fontSize: 14,
              fontFamily: 'Inter',
              fontWeight: 700,
              lineHeight: '14px',
              textAlign: 'center',
            }}
          >
            {name || '—'}
          </Typography>
        </Box>
      </Box>

      {/* Role */}
      <Typography
        sx={{
          alignSelf: 'stretch',
          textAlign: 'center',
          color: 'var(--Stroke-highlight, #F79420)',
          fontSize: 12,
          fontFamily: 'Inter',
          fontWeight: 500,
          lineHeight: '12px',
          '*': {
        fontFamily: 'Open Sans !important',
      },
      '*::before': {
        fontFamily: 'Open Sans !important',
      },
      '*::after': {
        fontFamily: 'Open Sans !important',
      },
        }}
      >
        {role}
      </Typography>
    </Box>
  );
};

interface MatchDetailsProps {
  openMatchDetails: any;
  handleCloseMatchDetails: any;
  matchDetails: any;
  matchDetailsLoader: any;
}

function MatchDetailsPopup({
  openMatchDetails,
  handleCloseMatchDetails,
  matchDetails,
  matchDetailsLoader,
}: MatchDetailsProps) {
  const loading = matchDetailsLoader && !matchDetails;
  const topics = topicArray();
  const industries = industryArray();

  const timestamp = matchDetails?.startDate;
  const date = timestamp ? new Date(timestamp * 1000) : null;
  const formattedDate = date
    ? date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })
    : null;

  /** BIO */
  const getBio = (mem: any) => {
    const { education, workHistory } = mem?.bio || {};
    const bio1 = bioFormatter(education?.major, education?.university);
    const bio2 = bioFormatter(workHistory?.role, workHistory?.companyName);
    return bio1 || bio2 || '';
  };

  /** USER CARDS */
  const UserinfoCardDetails = {
    mentee: {
      headshot: matchDetails?.mentee?.headshot,
      displayName: matchDetails?.mentee?.displayName,
      UserType: 'Mentee',
      bio: getBio(matchDetails?.mentee),
    },
    mentor: {
      headshot: matchDetails?.mentor?.headshot,
      displayName: matchDetails?.mentor?.displayName,
      UserType: 'Mentor',
      bio: getBio(matchDetails?.mentor),
    },
  };

  /** HEADER MIDDLE (MATCH TYPE + DATE) */
  const middleBox = () => (
    <Box
      sx={{
        width: 160,
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        alignItems: 'center',
        '*': {
        fontFamily: 'Open Sans !important',
      },
      '*::before': {
        fontFamily: 'Open Sans !important',
      },
      '*::after': {
        fontFamily: 'Open Sans !important',
      },
      }}
    >
      <Typography
        sx={{
          fontSize: 12,
          color: 'var(--Text-text-primary, #FDFDFD)',
          fontFamily: 'Inter',
          fontWeight: 500,
          textAlign: 'center',
        }}
      >
        Objective Match
      </Typography>

      <Box sx={{ display: 'flex', gap: 1 }}>
        <DoubleArrowIcon />
      </Box>

      <Typography
        sx={{
          fontSize: 12,
          fontWeight: 500,
          '*': {
        fontFamily: 'Open Sans !important',
      },
      '*::before': {
        fontFamily: 'Open Sans !important',
      },
      '*::after': {
        fontFamily: 'Open Sans !important',
      },
          color: 'var(--Text-text-primary, #FDFDFD)',
          textAlign: 'center',
        }}
      >
        {formattedDate || matchDetails?.startDate}
      </Typography>

      <Typography
        sx={{
          fontSize: 12,
          color: 'var(--Stroke-highlight, #F79420)',
          fontFamily: 'Inter',
          fontWeight: 500,
          textAlign: 'center',
        }}
      >
        {matchDetails?.status || 'Ongoing'}
      </Typography>
    </Box>
  );

  /** RENDER CHIPS */
  const renderChips = (values: any[], bg?: string) => (
    <Box display="flex" flexWrap="wrap" gap={1} mt={1}>
      {values.map((v, idx) => (
        <Typography color='white' key={idx} >{v}</Typography>
      ))}
    </Box>
  );

  /** MAIN CONTENT */
  const getMatchDetails = () => (
    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 3 }}>
      {/* TOP SECTION (MENTEE — MIDDLE — MENTOR) */}
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 4,
        }}
      >
        <MatchUserCard
  name={UserinfoCardDetails.mentee.displayName}
  headshot={UserinfoCardDetails.mentee.headshot}
  role="Mentee"
/>

        {middleBox()}

       <MatchUserCard
  name={UserinfoCardDetails.mentor.displayName}
  headshot={UserinfoCardDetails.mentor.headshot}
  role="Mentor"
/>
      </Box>

      <Divider sx={{ background: 'var(--Stroke-divider, #444444)', height: '1px !important' }} />

      {/* METRICS (Past / Future / Messages) */}
      <Box sx={{ display: 'flex', width: '100%', gap: 4,'*': {
        fontFamily: 'Open Sans !important',
      },
      '*::before': {
        fontFamily: 'Open Sans !important',
      },
      '*::after': {
        fontFamily: 'Open Sans !important',
      }, }}>
        {[
          { label: 'Past Calls', value: matchDetails?.pastCall },
          { label: 'Future Calls', value: matchDetails?.futureCall },
          { label: 'Messages Shared', value: matchDetails?.messagedShared },
        ].map((item, idx) => (
          <Box key={idx} sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Typography
              sx={{
                fontSize: 12,
                color: 'var(--Text-text-tertiary, #868686)',
                fontWeight: 700,
                fontFamily: 'Inter',
              }}
            >
              {item.label}
            </Typography>

            <Typography
              sx={{
                fontSize: 14,
                color: 'var(--Text-text-primary, #FDFDFD)',
                fontWeight: 400,
                fontFamily: 'Inter',
              }}
            >
              {formatNumberWithCommas(item.value) || '---'}
            </Typography>
          </Box>
        ))}
      </Box>

      <Divider sx={{ background: 'var(--Stroke-Border-border, #444444)' }} />

      {/* MATCHING CRITERIA TITLE */}
      <Typography
        sx={{
          fontSize: 16,
          color: 'var(--Text-text-primary, #FDFDFD)',
          fontWeight: 700,
          '*': {
        fontFamily: 'Open Sans !important',
      },
      '*::before': {
        fontFamily: 'Open Sans !important',
      },
      '*::after': {
        fontFamily: 'Open Sans !important',
      },
        }}
      >
        Matching Criteria
      </Typography>

      {/* CRITERIA CONTENT */}
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        {matchDetails?.searchQuery?.map((ele: any, index: number) => {
          const title =
            ele.field === 'industry'
              ? 'Work History'
              : capitalizeFirstLetter(ele.field);

          const showTitle = ele?.matchedValues?.length > 0 || ele?.unmatchedValues?.length > 0;

          return (
            <Box key={index} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              {showTitle && (
                <Typography
                  sx={{
                    fontSize: 16,
                    color: 'var(--Text-text-primary, #FDFDFD)',
                    '*': {
        fontFamily: 'Open Sans !important',
      },
      '*::before': {
        fontFamily: 'Open Sans !important',
      },
      '*::after': {
        fontFamily: 'Open Sans !important',
      },
                    fontWeight: 700,
                  }}
                >
                  {title}
                </Typography>
              )}

              {ele?.matchedValues?.length > 0 &&
                renderChips(ele.matchedValues)}

              {ele?.unmatchedValues?.length > 0 &&
                renderChips(ele.unmatchedValues)}
            </Box>
          );
        })}
      </Box>

      {/* <Divider sx={{ background: 'var(--Stroke-Border-border, #444444)' }} /> */}

      {/* OBJECTIVES */}
      {/* <Typography
        sx={{
          fontSize: 16,
          fontFamily: 'Inter',
          fontWeight: 700,
          color: 'var(--Text-text-primary, #FDFDFD)',
        }}
      >
        Objectives
      </Typography>

      <Typography
        sx={{
          fontSize: 14,
          color: 'var(--Text-text-primary, #FDFDFD)',
          fontFamily: 'Inter',
          fontWeight: 400,
        }}
      >
        {matchDetails?.objectiveId || '---'}
      </Typography> */}
    </Box>
  );

  return (
  <Box
    sx={{
      '*': {
        fontFamily: 'Open Sans !important',
      },
      '*::before': {
        fontFamily: 'Open Sans !important',
      },
      '*::after': {
        fontFamily: 'Open Sans !important',
      },
    }}
  >
    <Dialog
      fullWidth
      open={openMatchDetails}
      onClose={handleCloseMatchDetails}
      PaperProps={{
        sx: {
          background: 'var(--Fill-Modal-background, #0F0F0F)',
          borderRadius: '8px',
          outline: '1px solid var(--Stroke-Modal-border, #444444)',
          outlineOffset: '-1px',
        },
      }}
    >
      <CommonModalHeader
        title="Match Details"
        handleCloseModal={handleCloseMatchDetails}
      />

      <DialogContent sx={{ p: 3 }}>
        {loading ? <MatchDetailsPopupLoader /> : getMatchDetails()}
      </DialogContent>
    </Dialog>
  </Box>
);

}

export default MatchDetailsPopup;
